import React, {Suspense, lazy} from 'react';
import {ROUTE_ADD_PR_APPROVAL_CONFIG, ROUTE_EDIT_PR_APPROVAL_CONFIG, ROUTE_PR_APPROVAL_CONFIG} from '../../RoutePathConstant';
import {authLoader} from '../../loader';
import {Spin} from 'antd';

const PRApprovalConfig = lazy(() =>
  import('../../../screens/PRApprovalConfig')
    .then(module => ({default:module.PRApprovalConfig})));

const AddPRApprovalConfig = lazy(() =>
  import('../../../screens/PRApprovalConfig')
    .then(module => ({default:module.AddPRApprovalConfig})));

const EditPRApprovalConfig = lazy(() =>
  import('../../../screens/PRApprovalConfig')
    .then(module => ({default:module.EditPRApprovalConfig})));

const PRApprovalConfigNavigation = [
  {
    path: ROUTE_PR_APPROVAL_CONFIG,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <PRApprovalConfig />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_PR_APPROVAL_CONFIG,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddPRApprovalConfig />
      </Suspense>
    ),
  },
  {
    path: ROUTE_EDIT_PR_APPROVAL_CONFIG,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditPRApprovalConfig />
      </Suspense>
    ),
  },
];

export default PRApprovalConfigNavigation;
